import React, { useState, useMemo, useRef, memo } from 'react';
import { GetAllRoles, DeleteRole } from "../../api/endpoints";
import AddEditRole from './CURole';
import ReportContent from '../../component/tableDrawer/reportContent';
import ReportHeader from '../../component/tableDrawer/reportHeader';
import DeleteBtn from '../../component/tableDrawer/Tables/Components/TableActions/DeleteBtn';
import EditBtn from '../../component/tableDrawer/Tables/Components/TableActions/EditBtn';

const RolesC = () => {

    const [RoleID, setRoleID] = useState(null);
    const [isInsertLookupLoaded, setIsInsertLookupLoaded] = useState(false);

    const insertModal = useRef("insertRoleModal")
    const updateModal = useRef("UpdateRoleModal")

    const columns = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'nameEn',
            accessor: 'nameEN',
        },
        {
            id: 'action',
            Cell: ({ row: { original } }) =>
                <>
                    <DeleteBtn id={original.id} api={DeleteRole} />
                    <EditBtn id={original.id} onApply={updateRole} />
                </>
        }
    ], [])

    const updateRole = (roleID) => {
        setRoleID(roleID);
        updateModal.current.click()
    }

    const finishUpdate = () => {
        updateModal.current.click()
    }

    const handleOpenInsertModal = () => {
        insertModal.current.click()
        setIsInsertLookupLoaded(prev => true)
    }

    return (
        <>
            <AddEditRole modalID={insertModal} loadData={isInsertLookupLoaded} />
            <AddEditRole roleID={RoleID} modalID={updateModal} finishOperation={finishUpdate} />
            <ReportContent tableAPI={GetAllRoles} columns={columns}>
                <ReportHeader ApplyAction={handleOpenInsertModal} >
                    {/*<ReportSearch />*/}
                </ReportHeader>
            </ReportContent>
        </>
    );
}

export default memo(RolesC);